import { FaAward } from "react-icons/fa"
import { TbBriefcase } from "react-icons/tb"
import { BiHappyHeartEyes } from "react-icons/bi"

const data = [
    {id: 1, icon: <FaAward/>, title: "Experience", desc: "7+ Years in Industry"},
    {id: 2, icon: <TbBriefcase/>, title: 'Companies', desc: "Bespoke Labs · Andela · Stax · Reliance Health"},
    {id: 3, icon: <BiHappyHeartEyes/>, title: "Domains", desc: "Fintech · Healthcare · AI/ML · Platform Engineering" }
]

export default data;
